import React from "react";
import { Router, Route, Redirect, Switch } from "react-router-dom";
import { createBrowserHistory, createHashHistory } from "history";
import Home from './view/Home';
import Login from './view/Login/index';
import ARoute from './components/authRoute';//带验证的路由



// const hist = createBrowserHistory();
const hist = createHashHistory();

function App() {
  return (
    <Router history={hist}>
      <Switch>
        {/* <Route path="/" component={Login} exact /> */}
        <Route path="/login" component={Login} key="/login" />
        <ARoute path="/view" component={Home} key="/view" />
        <Redirect from="/" to="/view" exact />
        <Route >404 页面不见了</Route>
      </Switch>
    </Router>
  );
}

export default App;